import { render, staticRenderFns } from "./NoteHistoryModal.vue?vue&type=template&id=ecd1ea40&"
import script from "./NoteHistoryModal.vue?vue&type=script&lang=js&"
export * from "./NoteHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports